__turbopack_context__.v({
  "arrowBot": "erp-carousel-module-scss-module__41JM6W__arrowBot",
  "arrowTop": "erp-carousel-module-scss-module__41JM6W__arrowTop",
  "body": "erp-carousel-module-scss-module__41JM6W__body",
  "bodyMobile": "erp-carousel-module-scss-module__41JM6W__bodyMobile",
  "carouselContainer": "erp-carousel-module-scss-module__41JM6W__carouselContainer",
  "carouselContainerMobile": "erp-carousel-module-scss-module__41JM6W__carouselContainerMobile",
  "carouselItem": "erp-carousel-module-scss-module__41JM6W__carouselItem",
  "carouselWrapper": "erp-carousel-module-scss-module__41JM6W__carouselWrapper",
  "header": "erp-carousel-module-scss-module__41JM6W__header",
  "headerContainer": "erp-carousel-module-scss-module__41JM6W__headerContainer",
  "headerData": "erp-carousel-module-scss-module__41JM6W__headerData",
  "headerMobile": "erp-carousel-module-scss-module__41JM6W__headerMobile",
  "imgCont": "erp-carousel-module-scss-module__41JM6W__imgCont",
  "imgContainer": "erp-carousel-module-scss-module__41JM6W__imgContainer",
  "imgSetting": "erp-carousel-module-scss-module__41JM6W__imgSetting",
  "imgSlide": "erp-carousel-module-scss-module__41JM6W__imgSlide",
  "itemMobile": "erp-carousel-module-scss-module__41JM6W__itemMobile",
  "navigatie": "erp-carousel-module-scss-module__41JM6W__navigatie",
  "spacer": "erp-carousel-module-scss-module__41JM6W__spacer",
  "spacertxt": "erp-carousel-module-scss-module__41JM6W__spacertxt",
  "textContainer": "erp-carousel-module-scss-module__41JM6W__textContainer",
});
